export default __webpack_public_path__ + "static/media/E06.f989ab68.mp3";